import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useWallet } from '../../chain/WalletContext';
import { walletSignIn } from '../../chain/walletAuth';
import { shortAddress } from '../../chain/config';
import { BpMark } from '../BpLogo';

// Buyer signup: pick a name, connect the wallet, sign — done.
export default function Signup() {
    const { address, connect, hasWallet } = useWallet();
    const [username, setUsername] = useState('');
    const [phase, setPhase] = useState('idle');
    const [error, setError] = useState('');

    const createAccount = async () => {
        setError('');
        try {
            let addr = address;
            if (!addr) {
                setPhase('connecting');
                addr = await connect();
                if (!addr) { setPhase('idle'); return; }
            }
            setPhase('signing');
            const result = await walletSignIn(addr, username.trim() || undefined);
            toast.success(result.isNew ? 'Account created — welcome to BirrPlug!' : 'Welcome back!');
            window.location.replace(result.user.role === 'SELLER' ? '/dashboard' : '/');
        } catch (err) {
            setPhase('idle');
            setError(err.message === 'NO_WALLET'
                ? 'No wallet detected — install BirrWallet or MetaMask to continue.'
                : err.message);
        }
    };

    return (
        <div className="bp-auth-page">
            <div className="bp-auth-card">
                <div className="bp-auth-mark"><BpMark size={52} /></div>
                <h1>Create your account</h1>
                <p className="bp-auth-sub">
                    One wallet, one account — created the moment you sign.
                    <strong> No email, no password, no forms.</strong>
                </p>

                <label className="bp-auth-label" htmlFor="bp-username">Display name <span className="bp-dim">(optional)</span></label>
                <input
                    id="bp-username"
                    className="bp-auth-input"
                    placeholder="How should we call you?"
                    maxLength={40}
                    value={username}
                    disabled={phase !== 'idle'}
                    onChange={e => setUsername(e.target.value)}
                />

                {address && (
                    <div className="bp-auth-wallet-pill">
                        <span className="bp-wallet-dot live" />
                        <span className="bp-mono">{shortAddress(address)}</span>
                        <span className="bp-dim">connected</span>
                    </div>
                )}

                <button className="bp-btn-primary bp-auth-cta" onClick={createAccount} disabled={phase !== 'idle'}>
                    {phase === 'connecting' ? 'Connecting wallet…'
                        : phase === 'signing' ? 'Check your wallet — sign the message'
                        : address ? 'Create Account' : 'Connect Wallet & Create Account'}
                </button>

                {error && <p className="bp-auth-error">{error}</p>}

                <div className="bp-auth-links">
                    <span>Already have an account? <Link to="/login">Sign in</Link></span>
                    <span>Want to sell instead? <Link to="/join">Open a shop</Link></span>
                </div>

                {!hasWallet && (
                    <a className="bp-auth-getwallet" href="https://birr.foundation/wallet" target="_blank" rel="noreferrer">
                        Don't have a wallet? Get BirrWallet ↗
                    </a>
                )}
            </div>
        </div>
    );
}
